export { default } from './CanaisAtendimentoAreaCliente';
